/**
 * UI elements
 */
class Kosmopedia_UI {
    constructor() {
        this.initSmoothScroll();
        this.initSearchInput();
        this.initVideoOverlay();
        this.initTextAccordion();
        this.initFunctionalGroup();
        this.initAllergyGroup();
        this.initOpenAlphabet();
    }

    initSmoothScroll () {
        $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top - 120
                    }, 1000);
                }
            }
        });
    }

    initSearchInput () {
        let siteHeader = $('.site-header');
        let searchWrapper = $('.search-block');
        let searchIcon = searchWrapper.find('.open-search');
        let searchInput = searchWrapper.find('input');

        $(window).on('click', e => {
            searchInput.removeClass('is-active');
            siteHeader.removeClass('search-open');
        });

        searchIcon.on('click', e => {
            e.preventDefault();
            e.stopPropagation();
            searchInput.toggleClass('is-active').focus();
            siteHeader.toggleClass('search-open').focus();
        });

        searchInput.on('click', e => {
            e.stopPropagation();
        })
    }

    initVideoOverlay () {
        let videoBlock = $('.wp-block-video');
        let video = videoBlock.find('video');

        if (videoBlock.length) {
            videoBlock.append('<a href="" class="overlay"></a>');
            video.attr('controls', 'false');
            video.removeAttr('controls');
            video.addClass('is-hidden');

            let overlayVideo = videoBlock.find('.overlay');

            overlayVideo.on('click', e => {
                e.preventDefault();
                video.removeClass('is-hidden');
                overlayVideo.addClass('is-hidden');
                video.attr('controls', 'true');
                video.trigger('play');
            });
        }
    }

    initTextAccordion () {
        if ($(document.body).hasClass('js-ui-accordion-initialized')) {
            return;
        }

        $(document.body).addClass('js-ui-accordion-initialized');

        $(".accordion").each(function(i, item) {
            $(item).find('.accordion-content').css('height', 0);

            $(item).on("click", function () {
                let item = $(this);
                let contentWrapper = item.find('.accordion-content');
                let contentText = item.find('.accordion-content > div');
                let contentTitle = item.parent().find('.accordion-title > span');

                item.toggleClass('active');
                let newHeight = contentText.outerHeight();

                if (item.hasClass('active')) {
                    contentWrapper.css('height', 0);
                    contentTitle.text('Zwiń treść');

                    setTimeout(function() {
                        contentWrapper.css('height', newHeight + 'px');
                    }, 0);

                    setTimeout(function() {
                        contentWrapper.css('height', 'auto');
                    }, 500);
                } else {
                    contentWrapper.css('height', newHeight + 'px');
                    contentTitle.text('Rozwiń treść');

                    setTimeout(function() {
                        contentWrapper.css('height', 0);
                    }, 0);
                }
            });
        });
    }

    initFunctionalGroup () {
        let functionalGroup = $('.functional-group-wrapper');
        let functionalGroupListVal = functionalGroup.find('.functional-group-list').attr('data-group');
        let functionalGroupItem = functionalGroup.find('.functional-group-list-item');

        

        for (let i = 0; i < functionalGroupItem.length; i++) {
            let functionalGroupItemVal = functionalGroupItem.eq(i).attr('data-group');

            if(functionalGroupListVal.indexOf(functionalGroupItemVal) != -1) {
                functionalGroupItem.eq(i).addClass('is-active');
            }
        }
    }

    initAllergyGroup () {
        let allergyGroup = $('.allergy-group-wrapper');
        let allergyGroupListVal = allergyGroup.find('.allergy-group-list').attr('data-group');
        let allergyGroupItem = allergyGroup.find('.allergy-group-list-item');

        for (let i = 0; i < allergyGroupItem.length; i++) {
            let allergyGroupItemVal = allergyGroupItem.eq(i).attr('data-group');

            if (allergyGroupItemVal === allergyGroupListVal) {
                allergyGroupItem.eq(i).addClass('is-active');
            }
        }
    }

    initOpenAlphabet() {
        let openAlphabet = $('.open-alphabet');
        let alphabetList = $('.alphabet');
        let alphabetListLink = alphabetList.find('a');

        if (openAlphabet.length) {
            openAlphabet.on('click', e => {
                e.preventDefault();
                alphabetList.addClass('is-open');
            });

            alphabetListLink.on('click', e => {
                alphabetList.removeClass('is-open');
            });
        }
    }
}